import { createReducer } from "typesafe-actions";
import { accessCleared, accessLoaded } from "./actions";
import { AppAccessState } from "./types";

const initialState: AppAccessState = {
  role: null,
  pages: [],
  loaded: false,
};

export const accessReducer = createReducer<AppAccessState>({ ...initialState })
  .handleAction(
    accessLoaded,
    (state: AppAccessState, action: any): AppAccessState => {
      const access = action.payload ?? {};
      return {
        role: typeof access.role === "string" ? access.role : null,
        pages: Array.isArray(access.pages)
          ? access.pages.filter((p: unknown) => typeof p === "string")
          : [],
        loaded: true,
      };
    }
  )
  .handleAction(
    accessCleared,
    (): AppAccessState => ({ ...initialState })
  );
